// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "./analytics";
import "trix";
import "@rails/actiontext";

// this is now my preferred way of dealing with confirmation dialog
// it is just much simpler than Turbo way
document.addEventListener("click", (event) => {
  const element = event.target.closest("[data-confirm]");

  if (element && !confirm(element.dataset.confirm)) {
    event.preventDefault();
  }
});
